import { monthByNumber } from './admin/getEstimationMonths';

export default (name: string, currentDate: Date, date?: string): string => {
    const dateFormatted =
        currentDate.getDate() +
        '.' +
        ('0' + (currentDate.getMonth() + 1)).slice(-2) +
        '.' +
        currentDate.getFullYear() +
        '_' +
        currentDate.getHours() +
        '.' +
        currentDate.getMinutes();
    if (date) {
        const splitedDate = date.split('-');
        const detailsDate = monthByNumber[splitedDate[1]] + splitedDate[0];
        return `${name}_${detailsDate}_${dateFormatted}.xlsx`;
    } else {
        return `${name}_${dateFormatted}.xlsx`;
    }
};



// WEBPACK FOOTER //
// ./src/view/createExcelFileName.ts